import styled from "styled-components";

export const GridCard = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.columns.join(" ")};
  grid-column-gap: ${({ gap }) => gap || 0};

  @media (max-width: 960px) {
    display: block;
  }
`;

export const Button = styled.button`
  border: none;
  color: white;
  border-radius: ${({ radius }) => radius || "5px"};
  width: ${({ width }) => width || "fit-content"};
  cursor: pointer;
  display: inline-block;
  font-family: inherit;
  font-size: 0.75rem;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  height: 100%;
  line-height: 35px;
  outline: none;
  padding: ${({ padding }) => padding || "0 1.2em"};
  position: relative;
  text-decoration: none;
  transition: 0.25s cubic-bezier(0.17, 0.635, 0.54, 1.435);
  font-weight: 600;
  background-color: #26750a;
  text-transform: capitalize;
`;

export const ButtonYellow = styled(Button)`
  background-color: #cebf0a;
`;

export const Wrapper = styled.div`
  h1 {
    font-size: 24px;
    padding-bottom: 13px;
    border-bottom: 1px solid #ccd1d9;
    margin-bottom: 30px;
  }
`;
